module.exports = __webpack_public_path__ + "static/media/Safe-T23.bf388933.jpg";